export const normalizeArticleCode = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const digits = String(value).trim().replace(/[^0-9]/g, '').replace(/^0+/, '');
  return digits || '0';
};

export const normalizeBatchNumber = (value) =>
  String(value ?? '')
    .trim()
    .replace(/\s+/g, ' ')
    .toUpperCase();

export const normalizeSearchText = (value) =>
  String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .replace(/\s+/g, ' ')
    .toUpperCase();

export const formatDate = (value) => {
  if (!value) return '—';
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return String(value);
  return `${match[3]}/${match[2]}/${match[1]}`;
};

export const formatNumber = (value, maximumFractionDigits = 3) =>
  new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits,
  }).format(Number(value) || 0);

export const formatDateTime = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat('es-AR', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(date);
};

export const getEstadoVencimientoLabel = (estado) =>
  ({
    vencida: 'Vencida',
    critica: 'Crítica',
    alerta: 'Alerta',
    vigente: 'Vigente',
    sin_fecha_valida: 'Sin fecha válida',
  }[estado] || 'Sin clasificar');

export const getEstadoVencimientoClass = (estado) =>
  ({
    vencida: 'partidas-badge-danger',
    critica: 'partidas-badge-critical',
    alerta: 'partidas-badge-warning',
    vigente: 'partidas-badge-success',
    sin_fecha_valida: 'partidas-badge-neutral',
  }[estado] || 'partidas-badge-neutral');

export const downloadBlob = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
};
